export const names = {
    Configuration: 'configuration',
    Templates: 'templates',
};
